var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 27.75C23.3848 27.75 27.75 23.3848 27.75 18C27.75 12.6152 23.3848 8.25 18 8.25C12.6152 8.25 8.25 12.6152 8.25 18C8.25 23.3848 12.6152 27.75 18 27.75Z",
    stroke: "#172343",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.71 28.71L28.515 28.515M28.515 7.485L28.71 7.29L28.515 7.485ZM7.29 28.71L7.485 28.515L7.29 28.71ZM18 3.12V3V3.12ZM18 33V32.88V33ZM3.12 18H3H3.12ZM33 18H32.88H33ZM7.485 7.485L7.29 7.29L7.485 7.485Z",
    stroke: "#172343",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSun);
export default __webpack_public_path__ + "static/media/ic_sun.febfde30f8982a2a7051f72d0155c27b.svg";
export { ForwardRef as ReactComponent };